module.exports = __webpack_public_path__ + "vfn-assets/img/pase-400.21c36710.svg";